export interface ReviewFilterType {
    taskDate?: [string | null, string | null] | null;
    warehouseId: string | null;
    dspId: string | null;
    driverAccountId: string | null;
}

export const ReviewInitialValue: ReviewFilterType = {
    // 默认日期不写入 URL/hash：由页面/筛选组件在运行时展示“最近一周”
    taskDate: undefined,
    warehouseId: null,
    dspId: null,
    driverAccountId: null
}